import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import prettyBytes from 'pretty-bytes';

@customElement('ep-file-size')
export class EPFileSize extends LitElement {

  @property({ type: Number, attribute: 'size', reflect: true })
  sizeBytes: number = 0.0;

  render() {
    return html`
      ${prettyBytes(this.sizeBytes)}
    `
  }

  /* We don't want to use the ShadowDOM for such a simple element */
  protected override createRenderRoot() {
    return this;
  }

  static styles = css`
    :host {
      display: contents;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-file-size': EPFileSize
  }
}
